import { axiosApi } from "../../../api/dbAxios";

export const fetchRegulatorList = async () => {
  try {
    const response = await axiosApi.get(`/regulators/`);
    return response.data;
  } catch (error) {
    console.error("Error fetching regulators list:", error);
    return [];
  }
};
